import { GenIcon } from '../helpers/IconBase.es.js';

const ShoppingCartColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5.94238 8.09338L7.91086 15.8683L19.7461 15.889C19.9875 15.8894 20.1985 15.7261 20.2586 15.4922L21.983 8.78014C22.0687 8.44635 21.817 8.12116 21.4723 8.12053L5.94238 8.09338Z",
          fill: "#FF6D3A"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.919 14.7489C9.78806 14.7489 9.66881 14.6605 9.63521 14.5277L8.38404 9.58602C8.34431 9.42914 8.43927 9.2698 8.59615 9.23012C8.75314 9.19035 8.91236 9.28539 8.95205 9.44223L10.2032 14.384C10.2429 14.5408 10.148 14.7002 9.99111 14.7399C9.96697 14.746 9.94279 14.7489 9.919 14.7489Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.6122 14.7535C12.4614 14.7535 12.3333 14.6378 12.3205 14.4848L11.9092 9.54456C11.8958 9.38335 12.0156 9.24175 12.1769 9.22831C12.3382 9.21495 12.4797 9.33468 12.4932 9.49597L12.9045 14.4363C12.9179 14.5975 12.798 14.7391 12.6368 14.7525C12.6285 14.7532 12.6203 14.7535 12.6122 14.7535Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.3055 14.7583C15.297 14.7583 15.2884 14.7579 15.2799 14.7571C15.1186 14.7432 14.9993 14.6011 15.0133 14.44L15.4419 9.50116C15.4559 9.33999 15.5985 9.22065 15.7591 9.23463C15.9203 9.24862 16.0397 9.39065 16.0256 9.55182L15.597 14.4906C15.5838 14.6432 15.4559 14.7583 15.3055 14.7583Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M17.9988 14.7629C17.9747 14.7629 17.9501 14.7599 17.9257 14.7536C17.769 14.7134 17.6746 14.5537 17.7149 14.397L18.9833 9.45965C19.0235 9.30297 19.1831 9.20852 19.34 9.24879C19.4967 9.28906 19.5911 9.44875 19.5508 9.60543L18.2823 14.5428C18.2484 14.6751 18.1293 14.7629 17.9988 14.7629Z",
          fill: "#FFB125"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.7952 18.883L8.51922 18.8616C8.25051 18.8611 8.01633 18.6785 7.95035 18.418L4.83457 6.11185L2.37124 5.1345C2.06944 5.01473 1.92186 4.67301 2.04159 4.37126C2.16132 4.06946 2.50308 3.92188 2.80483 4.04157L5.54754 5.12977C5.72297 5.19934 5.85433 5.34895 5.90062 5.53188L8.97801 17.6866L20.7972 17.7073C21.1219 17.7079 21.3846 17.9715 21.3841 18.2962C21.3835 18.6209 21.1198 18.8836 20.7952 18.883Z",
          fill: "#CCCCCC"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.78223 20.0409C9.68509 20.0409 10.417 19.309 10.417 18.4061C10.417 17.5033 9.68509 16.7714 8.78223 16.7714C7.87937 16.7714 7.14746 17.5033 7.14746 18.4061C7.14746 19.309 7.87937 20.0409 8.78223 20.0409Z",
          fill: "#1D4859"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.78127 18.97C8.47029 18.9694 8.21772 18.716 8.21826 18.405C8.21881 18.094 8.47225 17.8415 8.78322 17.842C9.0942 17.8426 9.34674 18.096 9.34619 18.407C9.34569 18.7179 9.09225 18.9705 8.78127 18.97Z",
          fill: "#F3E8D6"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.3687 20.0576C19.2715 20.0576 20.0034 19.3257 20.0034 18.4229C20.0034 17.52 19.2715 16.7881 18.3687 16.7881C17.4658 16.7881 16.7339 17.52 16.7339 18.4229C16.7339 19.3257 17.4658 20.0576 18.3687 20.0576Z",
          fill: "#1D4859"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.3677 18.9867C18.0567 18.9862 17.8041 18.7327 17.8047 18.4217C17.8052 18.1108 18.0587 17.8582 18.3697 17.8588C18.6806 17.8593 18.9332 18.1127 18.9326 18.4237C18.9321 18.7347 18.6787 18.9872 18.3677 18.9867Z",
          fill: "#F3E8D6"
        }
      }
    ]
  })(props);
};

export { ShoppingCartColored };
